<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-alert
                        title="新添加的客户，满足默认公海回收规则将会被自动回收！"
                        type="warning"
                        :closable="false"
                    ></el-alert>
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item
                            label="名称："
                            prop="row.name"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="detailData.row.name"
                                placeholder="公司名称 / 门店 / 养殖场 / 个体户"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="地址："
                            prop="row.area"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-cascader
                                v-model="detailData.row.area"
                                :options="regionData.list"
                                filterable
                                clearable
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item prop="row.address">
                            <el-input
                                v-model="detailData.row.address"
                                placeholder="详细地址"
                            ></el-input>
                        </el-form-item>
                        <el-row :gutter="10">
                            <el-col :span="8">
                                <el-form-item label="类型：">
                                    <el-select
                                        v-model="detailData.row.customer_type_id"
                                        :loading="typeData.loading"
                                        clearable
                                    >
                                        <el-option
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                            :disabled="item.id === 1 || item.id === 2"
                                            v-for="item in typeData.list"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="来源：">
                                    <el-select
                                        v-model="detailData.row.customer_source_id"
                                        :loading="sourceData.loading"
                                        clearable
                                    >
                                        <el-option
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                            v-for="item in sourceData.list"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="级别：">
                                    <el-select
                                        v-model="detailData.row.customer_level_id"
                                        :loading="levelData.loading"
                                        clearable
                                    >
                                        <el-option
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                            v-for="item in levelData.list"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="备注：" prop="row.memo">
                            <el-input
                                type="textarea"
                                v-model="detailData.row.memo"
                                placeholder="其他信息"
                            ></el-input>
                        </el-form-item>
                        <h1>联系人</h1>
                        <el-form-item
                            label="姓名："
                            prop="row.contact_name"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                v-model="detailData.row.contact_name"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="职务：" prop="row.contact_post">
                            <el-input
                                v-model="detailData.row.contact_post"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="手机号："
                            prop="row.contact_mobilephone"
                            :rules="[
                                { required: true, message: ' ', trigger: 'blur' },
                                {
                                    pattern: /^1[3456789]\d{9}$/,
                                    message: '手机号码格式错误，请重新填写',
                                    trigger: 'blur'
                                }
                            ]"
                        >
                            <el-input
                                v-model.number="detailData.row.contact_mobilephone"
                                maxlength="11"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="座机："
                            prop="row.contact_telephone"
                            :rules="[
                                {
                                    pattern: /^0\d{9,10}$/,
                                    message: '座机号码格式错误，中间不能有任何空格或字符',
                                    trigger: 'blur'
                                }
                            ]"
                        >
                            <el-input
                                v-model="detailData.row.contact_telephone"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-row :gutter="10">
                            <el-col :span="8">
                                <el-form-item label="微信号：" prop="row.contact_weixin">
                                    <el-input
                                        v-model="detailData.row.contact_weixin"
                                        placeholder="请输入"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="QQ号：" prop="row.contact_qq">
                                    <el-input
                                        v-model.number="detailData.row.contact_qq"
                                        placeholder="请输入"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="旺旺号：" prop="row.contact_wangwang">
                                    <el-input
                                        v-model="detailData.row.contact_wangwang"
                                        placeholder="请输入"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="邮箱：" prop="row.contact_email">
                            <el-input
                                v-model="detailData.row.contact_email"
                                placeholder="请输入"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitCustomer('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { AreaData } from '@/plugin/Area'
import { CustomerData } from '@/plugin/Customer'
import { UserData } from '@/plugin/User'
export default {
    name: 'v-customer',
    inject: ['reload'],
    mixins: [AreaData, CustomerData, UserData],
    props: ['detailParam'],
    data() {
        return {
            sourceData: {
                list: []
            },
            typeData: {
                list: []
            },
            levelData: {
                list: []
            },
            userData: {
                list: []
            },
            detailData: {
                title: '客户详情',
                loading: {
                    main: false,
                    submit: false
                },
                row: {
                    id: null,
                    name: null,
                    area: null,
                    address: null,
                    customer_source_id: null,
                    customer_type_id: null,
                    customer_level_id: null,
                    follow_users_array: [],
                    follow_users: [],
                    memo: null,
                    contact_name: null,
                    contact_post: null,
                    contact_mobilephone: null,
                    contact_telephone: null,
                    contact_weixin: null,
                    contact_qq: null,
                    contact_wangwang: null,
                    contact_email: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            // 客户来源
            if (!this.sourceData.list.length) {
                this.detailData.loading.main = true
                this.GetSourceData({
                    order: 'DESC'
                }).then(res => {
                    this.detailData.loading.main = false
                    this.sourceData.list = res.list
                })
            }

            // 客户类型
            if (!this.typeData.list.length) {
                this.GetTypeData().then(res => {
                    this.typeData.list = res.list
                })
            }

            // 客户级别
            if (!this.levelData.list.length) {
                this.GetLevelData().then(res => {
                    this.levelData.list = res.list
                })
            }

            // 所有用户
            if (!this.userData.list.length) {
                this.GetUserData().then(res => {
                    this.userData.list = res.list
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row.customer_id) {
                this.GetCustomer()
            }
        })
    },
    methods: {
        GetCustomer() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/customer/' + this.detailParam.row.customer_id
            }).then(res => {
                this.detailData.loading.main = false
                this.detailData.row = res.data
                this.detailData.row.area = [res.data.province, res.data.city, res.data.county]
            })
        },
        SubmitCustomer(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.row.province = this.detailData.row.area[0]
                    this.detailData.row.city = this.detailData.row.area[1]
                    this.detailData.row.county = this.detailData.row.area[2]
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/customer_add',
                        params: {
                            ...this.detailParam.row,
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            if (this.detailParam.row.customer_id) {
                                this.detailParam.visible = false
                                this.$parent.GetSearch()
                            } else {
                                this.reload()
                            }
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
